export default "__VITE_ASSET__DC97t9XS__"